// UserStatusIndicator.js
import { connect } from 'react-redux';

import UserStatusIndicator from '../component/UserStatusIndicator.jsx';
import getUserData from '../selector/getUserData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import subscribeOnlineStatus from '../action/subscribeOnlineStatus.js';

const mapStateToProps = (state, { userId }) => {
  const isOnline = userId ? getUserData(state, userId, 'isOnline') : false;
  return {
    isOnline,
    isLiveStreaming: getLiveStreamData(state, [userId], 'isLiveStreaming'),
    isPrivateLiveStreamStarted: getLiveStreamData(
      state,
      [userId],
      'isPrivateLiveStreamStarted'
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    subscribeOnlineStatus: ({ userId }) =>
      dispatch(subscribeOnlineStatus({ userId })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserStatusIndicator);
